import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  AddOnData,
  FilteredPointCloudClassesOptions,
  FilteredPointCloudFormatOptions,
} from '../add-ons';
import { Card } from './card';
import { FilteredPointCloudContent } from './filtered-point-cloud-content';

type Props = {
  onChange: (data: AddOnData) => void;
  selected: boolean;
  spacing?: number;
  format?: FilteredPointCloudFormatOptions;
  classes?: FilteredPointCloudClassesOptions;
};

const FilteredPointCloudCard = (props: Props) => {
  const { t } = useTranslation('cloudProcessing');
  const [selected, setSelected] = React.useState(props.selected);

  const onToggle = () => {
    setSelected(!selected);
    props.onChange({ filteredPointCloud: { enabled: !selected } });
  };

  return (
    <Card
      selected={selected}
      title={t('setupDialog.addOns.filteredPointCloud.cardTitle', { ns: 'cloudProcessing' })}
      onClick={onToggle}
    >
      <FilteredPointCloudContent
        classes={props.classes}
        format={props.format}
        selected={selected}
        spacing={props.spacing}
        onChange={props.onChange}
      />
    </Card>
  );
};

export { FilteredPointCloudCard };
